import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { normTr } from "@/lib/ara";

let soz = null;
const dinleyiciler = new Set();

export const logoAnahtar = (m) => normTr(m).toUpperCase().replace(/[^A-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60);

export const logolariYenile = () => {
  soz = api.get("/marka-logolari").then((r) => Object.fromEntries(r.data.map((x) => [x.anahtar, x.surum]))).catch(() => { soz = null; return {}; });
  soz.then((m) => dinleyiciler.forEach((f) => f(m)));
  return soz;
};

export const useMarkaLogolari = () => {
  const [m, setM] = useState({});
  useEffect(() => {
    dinleyiciler.add(setM);
    (soz || logolariYenile()).then(setM);
    return () => { dinleyiciler.delete(setM); };
  }, []);
  return m;
};

export const logoUrl = (logolar, marka) => {
  const a = logoAnahtar(marka);
  return logolar[a] ? `${API}/marka-logolari/${a}/gorsel?v=${logolar[a]}` : null;
};
